var map = {
	"./prism-abap": [
		57876,
		57876
	],
	"./prism-abap.js": [
		57876,
		57876
	],
	"./prism-abap.min": [
		89849,
		89849
	],
	"./prism-abap.min.js": [
		89849,
		89849
	],
	"./prism-abnf": [
		19300,
		19300
	],
	"./prism-abnf.js": [
		19300,
		19300
	],
	"./prism-abnf.min": [
		29333,
		29333
	],
	"./prism-abnf.min.js": [
		29333,
		29333
	],
	"./prism-actionscript": [
		83182,
		83182
	],
	"./prism-actionscript.js": [
		83182,
		83182
	],
	"./prism-actionscript.min": [
		97033,
		97033
	],
	"./prism-actionscript.min.js": [
		97033,
		97033
	],
	"./prism-ada": [
		29316,
		29316
	],
	"./prism-ada.js": [
		29316,
		29316
	],
	"./prism-ada.min": [
		1125,
		1125
	],
	"./prism-ada.min.js": [
		1125,
		1125
	],
	"./prism-agda": [
		51870,
		51870
	],
	"./prism-agda.js": [
		51870,
		51870
	],
	"./prism-agda.min": [
		27722,
		27722
	],
	"./prism-agda.min.js": [
		27722,
		27722
	],
	"./prism-al": [
		58177,
		58177
	],
	"./prism-al.js": [
		58177,
		58177
	],
	"./prism-al.min": [
		74031,
		74031
	],
	"./prism-al.min.js": [
		74031,
		74031
	],
	"./prism-antlr4": [
		76236,
		76236
	],
	"./prism-antlr4.js": [
		76236,
		76236
	],
	"./prism-antlr4.min": [
		43269,
		43269
	],
	"./prism-antlr4.min.js": [
		43269,
		43269
	],
	"./prism-apacheconf": [
		1949,
		1949
	],
	"./prism-apacheconf.js": [
		1949,
		1949
	],
	"./prism-apacheconf.min": [
		43749,
		43749
	],
	"./prism-apacheconf.min.js": [
		43749,
		43749
	],
	"./prism-apex": [
		28101,
		28101
	],
	"./prism-apex.js": [
		28101,
		28101
	],
	"./prism-apex.min": [
		84846,
		84846
	],
	"./prism-apex.min.js": [
		84846,
		84846
	],
	"./prism-apl": [
		64598,
		64598
	],
	"./prism-apl.js": [
		64598,
		64598
	],
	"./prism-apl.min": [
		69187,
		69187
	],
	"./prism-apl.min.js": [
		69187,
		69187
	],
	"./prism-applescript": [
		34249,
		34249
	],
	"./prism-applescript.js": [
		34249,
		34249
	],
	"./prism-applescript.min": [
		83525,
		83525
	],
	"./prism-applescript.min.js": [
		83525,
		83525
	],
	"./prism-aql": [
		94041,
		94041
	],
	"./prism-aql.js": [
		94041,
		94041
	],
	"./prism-aql.min": [
		74243,
		74243
	],
	"./prism-aql.min.js": [
		74243,
		74243
	],
	"./prism-arduino": [
		32224,
		32224
	],
	"./prism-arduino.js": [
		32224,
		32224
	],
	"./prism-arduino.min": [
		17451,
		17451
	],
	"./prism-arduino.min.js": [
		17451,
		17451
	],
	"./prism-arff": [
		36224,
		36224
	],
	"./prism-arff.js": [
		36224,
		36224
	],
	"./prism-arff.min": [
		66193,
		66193
	],
	"./prism-arff.min.js": [
		66193,
		66193
	],
	"./prism-armasm": [
		4796,
		4796
	],
	"./prism-armasm.js": [
		4796,
		4796
	],
	"./prism-armasm.min": [
		5224,
		5224
	],
	"./prism-armasm.min.js": [
		5224,
		5224
	],
	"./prism-arturo": [
		16161,
		16161
	],
	"./prism-arturo.js": [
		16161,
		16161
	],
	"./prism-arturo.min": [
		13975,
		13975
	],
	"./prism-arturo.min.js": [
		13975,
		13975
	],
	"./prism-asciidoc": [
		79909,
		79909
	],
	"./prism-asciidoc.js": [
		79909,
		79909
	],
	"./prism-asciidoc.min": [
		78367,
		78367
	],
	"./prism-asciidoc.min.js": [
		78367,
		78367
	],
	"./prism-asm6502": [
		18623,
		18623
	],
	"./prism-asm6502.js": [
		18623,
		18623
	],
	"./prism-asm6502.min": [
		15347,
		15347
	],
	"./prism-asm6502.min.js": [
		15347,
		15347
	],
	"./prism-asmatmel": [
		18419,
		18419
	],
	"./prism-asmatmel.js": [
		18419,
		18419
	],
	"./prism-asmatmel.min": [
		15639,
		15639
	],
	"./prism-asmatmel.min.js": [
		15639,
		15639
	],
	"./prism-aspnet": [
		73418,
		73418
	],
	"./prism-aspnet.js": [
		73418,
		73418
	],
	"./prism-aspnet.min": [
		3301,
		3301
	],
	"./prism-aspnet.min.js": [
		3301,
		3301
	],
	"./prism-autohotkey": [
		38281,
		38281
	],
	"./prism-autohotkey.js": [
		38281,
		38281
	],
	"./prism-autohotkey.min": [
		71902,
		71902
	],
	"./prism-autohotkey.min.js": [
		71902,
		71902
	],
	"./prism-autoit": [
		74247,
		74247
	],
	"./prism-autoit.js": [
		74247,
		74247
	],
	"./prism-autoit.min": [
		18682,
		18682
	],
	"./prism-autoit.min.js": [
		18682,
		18682
	],
	"./prism-avisynth": [
		49173,
		49173
	],
	"./prism-avisynth.js": [
		49173,
		49173
	],
	"./prism-avisynth.min": [
		41594,
		41594
	],
	"./prism-avisynth.min.js": [
		41594,
		41594
	],
	"./prism-avro-idl": [
		49208,
		49208
	],
	"./prism-avro-idl.js": [
		49208,
		49208
	],
	"./prism-avro-idl.min": [
		2342,
		2342
	],
	"./prism-avro-idl.min.js": [
		2342,
		2342
	],
	"./prism-awk": [
		22698,
		22698
	],
	"./prism-awk.js": [
		22698,
		22698
	],
	"./prism-awk.min": [
		94709,
		94709
	],
	"./prism-awk.min.js": [
		94709,
		94709
	],
	"./prism-bash": [
		3209,
		3209
	],
	"./prism-bash.js": [
		3209,
		3209
	],
	"./prism-bash.min": [
		3745,
		3745
	],
	"./prism-bash.min.js": [
		3745,
		3745
	],
	"./prism-basic": [
		82959,
		82959
	],
	"./prism-basic.js": [
		82959,
		82959
	],
	"./prism-basic.min": [
		90039,
		90039
	],
	"./prism-basic.min.js": [
		90039,
		90039
	],
	"./prism-batch": [
		3946,
		3946
	],
	"./prism-batch.js": [
		3946,
		3946
	],
	"./prism-batch.min": [
		43820,
		43820
	],
	"./prism-batch.min.js": [
		43820,
		43820
	],
	"./prism-bbcode": [
		25246,
		25246
	],
	"./prism-bbcode.js": [
		25246,
		25246
	],
	"./prism-bbcode.min": [
		89307,
		89307
	],
	"./prism-bbcode.min.js": [
		89307,
		89307
	],
	"./prism-bbj": [
		2066,
		2066
	],
	"./prism-bbj.js": [
		2066,
		2066
	],
	"./prism-bbj.min": [
		5353,
		5353
	],
	"./prism-bbj.min.js": [
		5353,
		5353
	],
	"./prism-bicep": [
		50901,
		50901
	],
	"./prism-bicep.js": [
		50901,
		50901
	],
	"./prism-bicep.min": [
		54377,
		54377
	],
	"./prism-bicep.min.js": [
		54377,
		54377
	],
	"./prism-birb": [
		3277,
		3277
	],
	"./prism-birb.js": [
		3277,
		3277
	],
	"./prism-birb.min": [
		84720,
		84720
	],
	"./prism-birb.min.js": [
		84720,
		84720
	],
	"./prism-bison": [
		7581,
		7581
	],
	"./prism-bison.js": [
		7581,
		7581
	],
	"./prism-bison.min": [
		59019,
		59019
	],
	"./prism-bison.min.js": [
		59019,
		59019
	],
	"./prism-bnf": [
		25090,
		25090
	],
	"./prism-bnf.js": [
		25090,
		25090
	],
	"./prism-bnf.min": [
		36816,
		36816
	],
	"./prism-bnf.min.js": [
		36816,
		36816
	],
	"./prism-bqn": [
		89220,
		89220
	],
	"./prism-bqn.js": [
		89220,
		89220
	],
	"./prism-bqn.min": [
		35180,
		35180
	],
	"./prism-bqn.min.js": [
		35180,
		35180
	],
	"./prism-brainfuck": [
		56234,
		56234
	],
	"./prism-brainfuck.js": [
		56234,
		56234
	],
	"./prism-brainfuck.min": [
		52896,
		52896
	],
	"./prism-brainfuck.min.js": [
		52896,
		52896
	],
	"./prism-brightscript": [
		44869,
		44869
	],
	"./prism-brightscript.js": [
		44869,
		44869
	],
	"./prism-brightscript.min": [
		97798,
		97798
	],
	"./prism-brightscript.min.js": [
		97798,
		97798
	],
	"./prism-bro": [
		46400,
		46400
	],
	"./prism-bro.js": [
		46400,
		46400
	],
	"./prism-bro.min": [
		68222,
		68222
	],
	"./prism-bro.min.js": [
		68222,
		68222
	],
	"./prism-bsl": [
		76166,
		76166
	],
	"./prism-bsl.js": [
		76166,
		76166
	],
	"./prism-bsl.min": [
		31352,
		31352
	],
	"./prism-bsl.min.js": [
		31352,
		31352
	],
	"./prism-c": [
		50497,
		50497
	],
	"./prism-c.js": [
		50497,
		50497
	],
	"./prism-c.min": [
		65775,
		65775
	],
	"./prism-c.min.js": [
		65775,
		65775
	],
	"./prism-cfscript": [
		47080,
		47080
	],
	"./prism-cfscript.js": [
		47080,
		47080
	],
	"./prism-cfscript.min": [
		38051,
		38051
	],
	"./prism-cfscript.min.js": [
		38051,
		38051
	],
	"./prism-chaiscript": [
		35314,
		35314
	],
	"./prism-chaiscript.js": [
		35314,
		35314
	],
	"./prism-chaiscript.min": [
		6841,
		6841
	],
	"./prism-chaiscript.min.js": [
		6841,
		6841
	],
	"./prism-cil": [
		39220,
		39220
	],
	"./prism-cil.js": [
		39220,
		39220
	],
	"./prism-cil.min": [
		83397,
		83397
	],
	"./prism-cil.min.js": [
		83397,
		83397
	],
	"./prism-cilkc": [
		71332,
		71332
	],
	"./prism-cilkc.js": [
		71332,
		71332
	],
	"./prism-cilkc.min": [
		34802,
		34802
	],
	"./prism-cilkc.min.js": [
		34802,
		34802
	],
	"./prism-cilkcpp": [
		23169,
		23169
	],
	"./prism-cilkcpp.js": [
		23169,
		23169
	],
	"./prism-cilkcpp.min": [
		37303,
		37303
	],
	"./prism-cilkcpp.min.js": [
		37303,
		37303
	],
	"./prism-clike": [
		55308,
		55308
	],
	"./prism-clike.js": [
		55308,
		55308
	],
	"./prism-clike.min": [
		21997,
		21997
	],
	"./prism-clike.min.js": [
		21997,
		21997
	],
	"./prism-clojure": [
		41116,
		41116
	],
	"./prism-clojure.js": [
		41116,
		41116
	],
	"./prism-clojure.min": [
		34499,
		34499
	],
	"./prism-clojure.min.js": [
		34499,
		34499
	],
	"./prism-cmake": [
		4401,
		4401
	],
	"./prism-cmake.js": [
		4401,
		4401
	],
	"./prism-cmake.min": [
		44012,
		44012
	],
	"./prism-cmake.min.js": [
		44012,
		44012
	],
	"./prism-cobol": [
		80794,
		80794
	],
	"./prism-cobol.js": [
		80794,
		80794
	],
	"./prism-cobol.min": [
		1561,
		1561
	],
	"./prism-cobol.min.js": [
		1561,
		1561
	],
	"./prism-coffeescript": [
		45944,
		45944
	],
	"./prism-coffeescript.js": [
		45944,
		45944
	],
	"./prism-coffeescript.min": [
		66241,
		66241
	],
	"./prism-coffeescript.min.js": [
		66241,
		66241
	],
	"./prism-concurnas": [
		24030,
		24030
	],
	"./prism-concurnas.js": [
		24030,
		24030
	],
	"./prism-concurnas.min": [
		57311,
		57311
	],
	"./prism-concurnas.min.js": [
		57311,
		57311
	],
	"./prism-cooklang": [
		72725,
		72725
	],
	"./prism-cooklang.js": [
		72725,
		72725
	],
	"./prism-cooklang.min": [
		90740,
		90740
	],
	"./prism-cooklang.min.js": [
		90740,
		90740
	],
	"./prism-coq": [
		24853,
		24853
	],
	"./prism-coq.js": [
		24853,
		24853
	],
	"./prism-coq.min": [
		45069,
		45069
	],
	"./prism-coq.min.js": [
		45069,
		45069
	],
	"./prism-core": [
		17834,
		17834
	],
	"./prism-core.js": [
		17834,
		17834
	],
	"./prism-core.min": [
		30825,
		30825
	],
	"./prism-core.min.js": [
		30825,
		30825
	],
	"./prism-cpp": [
		86364,
		86364
	],
	"./prism-cpp.js": [
		86364,
		86364
	],
	"./prism-cpp.min": [
		28467,
		28467
	],
	"./prism-cpp.min.js": [
		28467,
		28467
	],
	"./prism-crystal": [
		81688,
		81688
	],
	"./prism-crystal.js": [
		81688,
		81688
	],
	"./prism-crystal.min": [
		21186,
		21186
	],
	"./prism-crystal.min.js": [
		21186,
		21186
	],
	"./prism-csharp": [
		56178,
		56178
	],
	"./prism-csharp.js": [
		56178,
		56178
	],
	"./prism-csharp.min": [
		30095,
		30095
	],
	"./prism-csharp.min.js": [
		30095,
		30095
	],
	"./prism-cshtml": [
		5434,
		5434
	],
	"./prism-cshtml.js": [
		5434,
		5434
	],
	"./prism-cshtml.min": [
		91862,
		91862
	],
	"./prism-cshtml.min.js": [
		91862,
		91862
	],
	"./prism-csp": [
		5107,
		5107
	],
	"./prism-csp.js": [
		5107,
		5107
	],
	"./prism-csp.min": [
		34279,
		34279
	],
	"./prism-csp.min.js": [
		34279,
		34279
	],
	"./prism-css": [
		93063,
		93063
	],
	"./prism-css-extras": [
		92971,
		92971
	],
	"./prism-css-extras.js": [
		92971,
		92971
	],
	"./prism-css-extras.min": [
		40811,
		40811
	],
	"./prism-css-extras.min.js": [
		40811,
		40811
	],
	"./prism-css.js": [
		93063,
		93063
	],
	"./prism-css.min": [
		54683,
		54683
	],
	"./prism-css.min.js": [
		54683,
		54683
	],
	"./prism-csv": [
		61118,
		61118
	],
	"./prism-csv.js": [
		61118,
		61118
	],
	"./prism-csv.min": [
		77434,
		77434
	],
	"./prism-csv.min.js": [
		77434,
		77434
	],
	"./prism-cue": [
		83968,
		83968
	],
	"./prism-cue.js": [
		83968,
		83968
	],
	"./prism-cue.min": [
		42205,
		42205
	],
	"./prism-cue.min.js": [
		42205,
		42205
	],
	"./prism-cypher": [
		54034,
		54034
	],
	"./prism-cypher.js": [
		54034,
		54034
	],
	"./prism-cypher.min": [
		51589,
		51589
	],
	"./prism-cypher.min.js": [
		51589,
		51589
	],
	"./prism-d": [
		61122,
		61122
	],
	"./prism-d.js": [
		61122,
		61122
	],
	"./prism-d.min": [
		96699,
		96699
	],
	"./prism-d.min.js": [
		96699,
		96699
	],
	"./prism-dart": [
		41707,
		41707
	],
	"./prism-dart.js": [
		41707,
		41707
	],
	"./prism-dart.min": [
		58930,
		58930
	],
	"./prism-dart.min.js": [
		58930,
		58930
	],
	"./prism-dataweave": [
		93790,
		93790
	],
	"./prism-dataweave.js": [
		93790,
		93790
	],
	"./prism-dataweave.min": [
		3402,
		3402
	],
	"./prism-dataweave.min.js": [
		3402,
		3402
	],
	"./prism-dax": [
		68161,
		68161
	],
	"./prism-dax.js": [
		68161,
		68161
	],
	"./prism-dax.min": [
		19672,
		19672
	],
	"./prism-dax.min.js": [
		19672,
		19672
	],
	"./prism-dhall": [
		33018,
		33018
	],
	"./prism-dhall.js": [
		33018,
		33018
	],
	"./prism-dhall.min": [
		92536,
		92536
	],
	"./prism-dhall.min.js": [
		92536,
		92536
	],
	"./prism-diff": [
		93931,
		93931
	],
	"./prism-diff.js": [
		93931,
		93931
	],
	"./prism-diff.min": [
		88486,
		88486
	],
	"./prism-diff.min.js": [
		88486,
		88486
	],
	"./prism-django": [
		5627,
		5627
	],
	"./prism-django.js": [
		5627,
		5627
	],
	"./prism-django.min": [
		31322,
		31322
	],
	"./prism-django.min.js": [
		31322,
		31322
	],
	"./prism-dns-zone-file": [
		75624,
		75624
	],
	"./prism-dns-zone-file.js": [
		75624,
		75624
	],
	"./prism-dns-zone-file.min": [
		7480,
		7480
	],
	"./prism-dns-zone-file.min.js": [
		7480,
		7480
	],
	"./prism-docker": [
		25495,
		25495
	],
	"./prism-docker.js": [
		25495,
		25495
	],
	"./prism-docker.min": [
		6514,
		6514
	],
	"./prism-docker.min.js": [
		6514,
		6514
	],
	"./prism-dot": [
		71991,
		71991
	],
	"./prism-dot.js": [
		71991,
		71991
	],
	"./prism-dot.min": [
		64860,
		64860
	],
	"./prism-dot.min.js": [
		64860,
		64860
	],
	"./prism-ebnf": [
		88250,
		88250
	],
	"./prism-ebnf.js": [
		88250,
		88250
	],
	"./prism-ebnf.min": [
		64333,
		64333
	],
	"./prism-ebnf.min.js": [
		64333,
		64333
	],
	"./prism-editorconfig": [
		64352,
		64352
	],
	"./prism-editorconfig.js": [
		64352,
		64352
	],
	"./prism-editorconfig.min": [
		63532,
		63532
	],
	"./prism-editorconfig.min.js": [
		63532,
		63532
	],
	"./prism-eiffel": [
		77346,
		77346
	],
	"./prism-eiffel.js": [
		77346,
		77346
	],
	"./prism-eiffel.min": [
		2170,
		2170
	],
	"./prism-eiffel.min.js": [
		2170,
		2170
	],
	"./prism-ejs": [
		88684,
		88684
	],
	"./prism-ejs.js": [
		88684,
		88684
	],
	"./prism-ejs.min": [
		88528,
		88528
	],
	"./prism-ejs.min.js": [
		88528,
		88528
	],
	"./prism-elixir": [
		26930,
		26930
	],
	"./prism-elixir.js": [
		26930,
		26930
	],
	"./prism-elixir.min": [
		94930,
		94930
	],
	"./prism-elixir.min.js": [
		94930,
		94930
	],
	"./prism-elm": [
		57972,
		57972
	],
	"./prism-elm.js": [
		57972,
		57972
	],
	"./prism-elm.min": [
		90556,
		90556
	],
	"./prism-elm.min.js": [
		90556,
		90556
	],
	"./prism-erb": [
		82151,
		82151
	],
	"./prism-erb.js": [
		82151,
		82151
	],
	"./prism-erb.min": [
		58240,
		58240
	],
	"./prism-erb.min.js": [
		58240,
		58240
	],
	"./prism-erlang": [
		5558,
		5558
	],
	"./prism-erlang.js": [
		5558,
		5558
	],
	"./prism-erlang.min": [
		49430,
		49430
	],
	"./prism-erlang.min.js": [
		49430,
		49430
	],
	"./prism-etlua": [
		15540,
		15540
	],
	"./prism-etlua.js": [
		15540,
		15540
	],
	"./prism-etlua.min": [
		37390,
		37390
	],
	"./prism-etlua.min.js": [
		37390,
		37390
	],
	"./prism-excel-formula": [
		90345,
		90345
	],
	"./prism-excel-formula.js": [
		90345,
		90345
	],
	"./prism-excel-formula.min": [
		779,
		779
	],
	"./prism-excel-formula.min.js": [
		779,
		779
	],
	"./prism-factor": [
		99538,
		99538
	],
	"./prism-factor.js": [
		99538,
		99538
	],
	"./prism-factor.min": [
		52443,
		52443
	],
	"./prism-factor.min.js": [
		52443,
		52443
	],
	"./prism-false": [
		32578,
		32578
	],
	"./prism-false.js": [
		32578,
		32578
	],
	"./prism-false.min": [
		60984,
		60984
	],
	"./prism-false.min.js": [
		60984,
		60984
	],
	"./prism-firestore-security-rules": [
		64412,
		64412
	],
	"./prism-firestore-security-rules.js": [
		64412,
		64412
	],
	"./prism-firestore-security-rules.min": [
		67958,
		67958
	],
	"./prism-firestore-security-rules.min.js": [
		67958,
		67958
	],
	"./prism-flow": [
		12509,
		12509
	],
	"./prism-flow.js": [
		12509,
		12509
	],
	"./prism-flow.min": [
		95626,
		95626
	],
	"./prism-flow.min.js": [
		95626,
		95626
	],
	"./prism-fortran": [
		52516,
		52516
	],
	"./prism-fortran.js": [
		52516,
		52516
	],
	"./prism-fortran.min": [
		29304,
		29304
	],
	"./prism-fortran.min.js": [
		29304,
		29304
	],
	"./prism-fsharp": [
		35287,
		35287
	],
	"./prism-fsharp.js": [
		35287,
		35287
	],
	"./prism-fsharp.min": [
		69419,
		69419
	],
	"./prism-fsharp.min.js": [
		69419,
		69419
	],
	"./prism-ftl": [
		53930,
		53930
	],
	"./prism-ftl.js": [
		53930,
		53930
	],
	"./prism-ftl.min": [
		46171,
		46171
	],
	"./prism-ftl.min.js": [
		46171,
		46171
	],
	"./prism-gap": [
		79729,
		79729
	],
	"./prism-gap.js": [
		79729,
		79729
	],
	"./prism-gap.min": [
		8111,
		8111
	],
	"./prism-gap.min.js": [
		8111,
		8111
	],
	"./prism-gcode": [
		83830,
		83830
	],
	"./prism-gcode.js": [
		83830,
		83830
	],
	"./prism-gcode.min": [
		51722,
		51722
	],
	"./prism-gcode.min.js": [
		51722,
		51722
	],
	"./prism-gdscript": [
		24093,
		24093
	],
	"./prism-gdscript.js": [
		24093,
		24093
	],
	"./prism-gdscript.min": [
		27936,
		27936
	],
	"./prism-gdscript.min.js": [
		27936,
		27936
	],
	"./prism-gedcom": [
		72043,
		72043
	],
	"./prism-gedcom.js": [
		72043,
		72043
	],
	"./prism-gedcom.min": [
		48238,
		48238
	],
	"./prism-gedcom.min.js": [
		48238,
		48238
	],
	"./prism-gettext": [
		54525,
		54525
	],
	"./prism-gettext.js": [
		54525,
		54525
	],
	"./prism-gettext.min": [
		69198,
		69198
	],
	"./prism-gettext.min.js": [
		69198,
		69198
	],
	"./prism-gherkin": [
		44589,
		44589
	],
	"./prism-gherkin.js": [
		44589,
		44589
	],
	"./prism-gherkin.min": [
		97161,
		97161
	],
	"./prism-gherkin.min.js": [
		97161,
		97161
	],
	"./prism-git": [
		55267,
		55267
	],
	"./prism-git.js": [
		55267,
		55267
	],
	"./prism-git.min": [
		25105,
		25105
	],
	"./prism-git.min.js": [
		25105,
		25105
	],
	"./prism-glsl": [
		15232,
		85858
	],
	"./prism-glsl.js": [
		15232,
		85858
	],
	"./prism-glsl.min": [
		36595,
		36595
	],
	"./prism-glsl.min.js": [
		36595,
		36595
	],
	"./prism-gml": [
		79799,
		79799
	],
	"./prism-gml.js": [
		79799,
		79799
	],
	"./prism-gml.min": [
		81838,
		81838
	],
	"./prism-gml.min.js": [
		81838,
		81838
	],
	"./prism-gn": [
		23235,
		23235
	],
	"./prism-gn.js": [
		23235,
		23235
	],
	"./prism-gn.min": [
		87159,
		87159
	],
	"./prism-gn.min.js": [
		87159,
		87159
	],
	"./prism-go": [
		63492,
		63492
	],
	"./prism-go-module": [
		15276,
		15276
	],
	"./prism-go-module.js": [
		15276,
		15276
	],
	"./prism-go-module.min": [
		34585,
		34585
	],
	"./prism-go-module.min.js": [
		34585,
		34585
	],
	"./prism-go.js": [
		63492,
		63492
	],
	"./prism-go.min": [
		26290,
		26290
	],
	"./prism-go.min.js": [
		26290,
		26290
	],
	"./prism-gradle": [
		52436,
		52436
	],
	"./prism-gradle.js": [
		52436,
		52436
	],
	"./prism-gradle.min": [
		49265,
		49265
	],
	"./prism-gradle.min.js": [
		49265,
		49265
	],
	"./prism-graphql": [
		14989,
		14989
	],
	"./prism-graphql.js": [
		14989,
		14989
	],
	"./prism-graphql.min": [
		73473,
		73473
	],
	"./prism-graphql.min.js": [
		73473,
		73473
	],
	"./prism-groovy": [
		91199,
		48018
	],
	"./prism-groovy.js": [
		91199,
		48018
	],
	"./prism-groovy.min": [
		22537,
		22537
	],
	"./prism-groovy.min.js": [
		22537,
		22537
	],
	"./prism-haml": [
		51441,
		51441
	],
	"./prism-haml.js": [
		51441,
		51441
	],
	"./prism-haml.min": [
		62458,
		62458
	],
	"./prism-haml.min.js": [
		62458,
		62458
	],
	"./prism-handlebars": [
		18810,
		18810
	],
	"./prism-handlebars.js": [
		18810,
		18810
	],
	"./prism-handlebars.min": [
		34555,
		34555
	],
	"./prism-handlebars.min.js": [
		34555,
		34555
	],
	"./prism-haskell": [
		50444,
		50444
	],
	"./prism-haskell.js": [
		50444,
		50444
	],
	"./prism-haskell.min": [
		96470,
		96470
	],
	"./prism-haskell.min.js": [
		96470,
		96470
	],
	"./prism-haxe": [
		68615,
		68615
	],
	"./prism-haxe.js": [
		68615,
		68615
	],
	"./prism-haxe.min": [
		65917,
		65917
	],
	"./prism-haxe.min.js": [
		65917,
		65917
	],
	"./prism-hcl": [
		7465,
		7465
	],
	"./prism-hcl.js": [
		7465,
		7465
	],
	"./prism-hcl.min": [
		32024,
		32024
	],
	"./prism-hcl.min.js": [
		32024,
		32024
	],
	"./prism-hlsl": [
		88753,
		88753
	],
	"./prism-hlsl.js": [
		88753,
		88753
	],
	"./prism-hlsl.min": [
		44958,
		44958
	],
	"./prism-hlsl.min.js": [
		44958,
		44958
	],
	"./prism-hoon": [
		52915,
		52915
	],
	"./prism-hoon.js": [
		52915,
		52915
	],
	"./prism-hoon.min": [
		79522,
		79522
	],
	"./prism-hoon.min.js": [
		79522,
		79522
	],
	"./prism-hpkp": [
		13542,
		13542
	],
	"./prism-hpkp.js": [
		13542,
		13542
	],
	"./prism-hpkp.min": [
		50591,
		50591
	],
	"./prism-hpkp.min.js": [
		50591,
		50591
	],
	"./prism-hsts": [
		26151,
		26151
	],
	"./prism-hsts.js": [
		26151,
		26151
	],
	"./prism-hsts.min": [
		36463,
		36463
	],
	"./prism-hsts.min.js": [
		36463,
		36463
	],
	"./prism-http": [
		78546,
		78546
	],
	"./prism-http.js": [
		78546,
		78546
	],
	"./prism-http.min": [
		66878,
		66878
	],
	"./prism-http.min.js": [
		66878,
		66878
	],
	"./prism-ichigojam": [
		83470,
		83470
	],
	"./prism-ichigojam.js": [
		83470,
		83470
	],
	"./prism-ichigojam.min": [
		95895,
		95895
	],
	"./prism-ichigojam.min.js": [
		95895,
		95895
	],
	"./prism-icon": [
		82101,
		82101
	],
	"./prism-icon.js": [
		82101,
		82101
	],
	"./prism-icon.min": [
		77442,
		77442
	],
	"./prism-icon.min.js": [
		77442,
		77442
	],
	"./prism-icu-message-format": [
		74891,
		74891
	],
	"./prism-icu-message-format.js": [
		74891,
		74891
	],
	"./prism-icu-message-format.min": [
		13477,
		13477
	],
	"./prism-icu-message-format.min.js": [
		13477,
		13477
	],
	"./prism-idris": [
		91903,
		91903
	],
	"./prism-idris.js": [
		91903,
		91903
	],
	"./prism-idris.min": [
		47639,
		47639
	],
	"./prism-idris.min.js": [
		47639,
		47639
	],
	"./prism-iecst": [
		44592,
		44592
	],
	"./prism-iecst.js": [
		44592,
		44592
	],
	"./prism-iecst.min": [
		66676,
		66676
	],
	"./prism-iecst.min.js": [
		66676,
		66676
	],
	"./prism-ignore": [
		1638,
		1638
	],
	"./prism-ignore.js": [
		1638,
		1638
	],
	"./prism-ignore.min": [
		14856,
		14856
	],
	"./prism-ignore.min.js": [
		14856,
		14856
	],
	"./prism-inform7": [
		17952,
		17952
	],
	"./prism-inform7.js": [
		17952,
		17952
	],
	"./prism-inform7.min": [
		37877,
		37877
	],
	"./prism-inform7.min.js": [
		37877,
		37877
	],
	"./prism-ini": [
		47900,
		47900
	],
	"./prism-ini.js": [
		47900,
		47900
	],
	"./prism-ini.min": [
		68585,
		68585
	],
	"./prism-ini.min.js": [
		68585,
		68585
	],
	"./prism-io": [
		76342,
		76342
	],
	"./prism-io.js": [
		76342,
		76342
	],
	"./prism-io.min": [
		8812,
		8812
	],
	"./prism-io.min.js": [
		8812,
		8812
	],
	"./prism-j": [
		91929,
		91929
	],
	"./prism-j.js": [
		91929,
		91929
	],
	"./prism-j.min": [
		36602,
		36602
	],
	"./prism-j.min.js": [
		36602,
		36602
	],
	"./prism-java": [
		50955,
		50955
	],
	"./prism-java.js": [
		50955,
		50955
	],
	"./prism-java.min": [
		18751,
		18751
	],
	"./prism-java.min.js": [
		18751,
		18751
	],
	"./prism-javadoc": [
		8210,
		8210
	],
	"./prism-javadoc.js": [
		8210,
		8210
	],
	"./prism-javadoc.min": [
		71846,
		71846
	],
	"./prism-javadoc.min.js": [
		71846,
		71846
	],
	"./prism-javadoclike": [
		32527,
		32527
	],
	"./prism-javadoclike.js": [
		32527,
		32527
	],
	"./prism-javadoclike.min": [
		32589,
		32589
	],
	"./prism-javadoclike.min.js": [
		32589,
		32589
	],
	"./prism-javascript": [
		64326,
		64326
	],
	"./prism-javascript.js": [
		64326,
		64326
	],
	"./prism-javascript.min": [
		42454,
		42454
	],
	"./prism-javascript.min.js": [
		42454,
		42454
	],
	"./prism-javastacktrace": [
		79172,
		79172
	],
	"./prism-javastacktrace.js": [
		79172,
		79172
	],
	"./prism-javastacktrace.min": [
		17824,
		17824
	],
	"./prism-javastacktrace.min.js": [
		17824,
		17824
	],
	"./prism-jexl": [
		57604,
		57604
	],
	"./prism-jexl.js": [
		57604,
		57604
	],
	"./prism-jexl.min": [
		89135,
		89135
	],
	"./prism-jexl.min.js": [
		89135,
		89135
	],
	"./prism-jolie": [
		20192,
		20192
	],
	"./prism-jolie.js": [
		20192,
		20192
	],
	"./prism-jolie.min": [
		76970,
		76970
	],
	"./prism-jolie.min.js": [
		76970,
		76970
	],
	"./prism-jq": [
		82142,
		82142
	],
	"./prism-jq.js": [
		82142,
		82142
	],
	"./prism-jq.min": [
		75685,
		75685
	],
	"./prism-jq.min.js": [
		75685,
		75685
	],
	"./prism-js-extras": [
		5018,
		5018
	],
	"./prism-js-extras.js": [
		5018,
		5018
	],
	"./prism-js-extras.min": [
		61388,
		91199
	],
	"./prism-js-extras.min.js": [
		61388,
		91199
	],
	"./prism-js-templates": [
		46781,
		46781
	],
	"./prism-js-templates.js": [
		46781,
		46781
	],
	"./prism-js-templates.min": [
		99905,
		99905
	],
	"./prism-js-templates.min.js": [
		99905,
		99905
	],
	"./prism-jsdoc": [
		9510,
		15232
	],
	"./prism-jsdoc.js": [
		9510,
		15232
	],
	"./prism-jsdoc.min": [
		53697,
		53697
	],
	"./prism-jsdoc.min.js": [
		53697,
		53697
	],
	"./prism-json": [
		21417,
		21417
	],
	"./prism-json.js": [
		21417,
		21417
	],
	"./prism-json.min": [
		75256,
		75256
	],
	"./prism-json.min.js": [
		75256,
		75256
	],
	"./prism-json5": [
		71567,
		71567
	],
	"./prism-json5.js": [
		71567,
		71567
	],
	"./prism-json5.min": [
		6444,
		6444
	],
	"./prism-json5.min.js": [
		6444,
		6444
	],
	"./prism-jsonp": [
		54348,
		54348
	],
	"./prism-jsonp.js": [
		54348,
		54348
	],
	"./prism-jsonp.min": [
		49078,
		49078
	],
	"./prism-jsonp.min.js": [
		49078,
		49078
	],
	"./prism-jsstacktrace": [
		73152,
		73152
	],
	"./prism-jsstacktrace.js": [
		73152,
		73152
	],
	"./prism-jsstacktrace.min": [
		25874,
		25874
	],
	"./prism-jsstacktrace.min.js": [
		25874,
		25874
	],
	"./prism-jsx": [
		88257,
		88257
	],
	"./prism-jsx.js": [
		88257,
		88257
	],
	"./prism-jsx.min": [
		59819,
		59819
	],
	"./prism-jsx.min.js": [
		59819,
		59819
	],
	"./prism-julia": [
		32769,
		32769
	],
	"./prism-julia.js": [
		32769,
		32769
	],
	"./prism-julia.min": [
		40981,
		40981
	],
	"./prism-julia.min.js": [
		40981,
		40981
	],
	"./prism-keepalived": [
		76551,
		76551
	],
	"./prism-keepalived.js": [
		76551,
		76551
	],
	"./prism-keepalived.min": [
		36662,
		36662
	],
	"./prism-keepalived.min.js": [
		36662,
		36662
	],
	"./prism-keyman": [
		98319,
		98319
	],
	"./prism-keyman.js": [
		98319,
		98319
	],
	"./prism-keyman.min": [
		2197,
		2197
	],
	"./prism-keyman.min.js": [
		2197,
		2197
	],
	"./prism-kotlin": [
		81798,
		81798
	],
	"./prism-kotlin.js": [
		81798,
		81798
	],
	"./prism-kotlin.min": [
		44575,
		44575
	],
	"./prism-kotlin.min.js": [
		44575,
		44575
	],
	"./prism-kumir": [
		81904,
		81904
	],
	"./prism-kumir.js": [
		81904,
		81904
	],
	"./prism-kumir.min": [
		84845,
		84845
	],
	"./prism-kumir.min.js": [
		84845,
		84845
	],
	"./prism-kusto": [
		39924,
		39924
	],
	"./prism-kusto.js": [
		39924,
		39924
	],
	"./prism-kusto.min": [
		20492,
		20492
	],
	"./prism-kusto.min.js": [
		20492,
		20492
	],
	"./prism-latex": [
		17017,
		17017
	],
	"./prism-latex.js": [
		17017,
		17017
	],
	"./prism-latex.min": [
		12835,
		12835
	],
	"./prism-latex.min.js": [
		12835,
		12835
	],
	"./prism-latte": [
		81326,
		81326
	],
	"./prism-latte.js": [
		81326,
		81326
	],
	"./prism-latte.min": [
		66561,
		66561
	],
	"./prism-latte.min.js": [
		66561,
		66561
	],
	"./prism-less": [
		11601,
		11601
	],
	"./prism-less.js": [
		11601,
		11601
	],
	"./prism-less.min": [
		56580,
		56580
	],
	"./prism-less.min.js": [
		56580,
		56580
	],
	"./prism-lilypond": [
		19033,
		19033
	],
	"./prism-lilypond.js": [
		19033,
		19033
	],
	"./prism-lilypond.min": [
		5258,
		5258
	],
	"./prism-lilypond.min.js": [
		5258,
		5258
	],
	"./prism-linker-script": [
		71874,
		71874
	],
	"./prism-linker-script.js": [
		71874,
		71874
	],
	"./prism-linker-script.min": [
		1156,
		1156
	],
	"./prism-linker-script.min.js": [
		1156,
		1156
	],
	"./prism-liquid": [
		86989,
		86989
	],
	"./prism-liquid.js": [
		86989,
		86989
	],
	"./prism-liquid.min": [
		51999,
		51999
	],
	"./prism-liquid.min.js": [
		51999,
		51999
	],
	"./prism-lisp": [
		90174,
		90174
	],
	"./prism-lisp.js": [
		90174,
		90174
	],
	"./prism-lisp.min": [
		15472,
		15472
	],
	"./prism-lisp.min.js": [
		15472,
		15472
	],
	"./prism-livescript": [
		34437,
		34437
	],
	"./prism-livescript.js": [
		34437,
		34437
	],
	"./prism-livescript.min": [
		30218,
		30218
	],
	"./prism-livescript.min.js": [
		30218,
		30218
	],
	"./prism-llvm": [
		55031,
		55031
	],
	"./prism-llvm.js": [
		55031,
		55031
	],
	"./prism-llvm.min": [
		93566,
		93566
	],
	"./prism-llvm.min.js": [
		93566,
		93566
	],
	"./prism-log": [
		22385,
		22385
	],
	"./prism-log.js": [
		22385,
		22385
	],
	"./prism-log.min": [
		69453,
		69453
	],
	"./prism-log.min.js": [
		69453,
		69453
	],
	"./prism-lolcode": [
		18305,
		18305
	],
	"./prism-lolcode.js": [
		18305,
		18305
	],
	"./prism-lolcode.min": [
		65157,
		65157
	],
	"./prism-lolcode.min.js": [
		65157,
		65157
	],
	"./prism-lua": [
		60505,
		60505
	],
	"./prism-lua.js": [
		60505,
		60505
	],
	"./prism-lua.min": [
		49531,
		49531
	],
	"./prism-lua.min.js": [
		49531,
		49531
	],
	"./prism-magma": [
		70410,
		70410
	],
	"./prism-magma.js": [
		70410,
		70410
	],
	"./prism-magma.min": [
		44475,
		44475
	],
	"./prism-magma.min.js": [
		44475,
		44475
	],
	"./prism-makefile": [
		71694,
		71694
	],
	"./prism-makefile.js": [
		71694,
		71694
	],
	"./prism-makefile.min": [
		6828,
		6828
	],
	"./prism-makefile.min.js": [
		6828,
		6828
	],
	"./prism-markdown": [
		64746,
		64746
	],
	"./prism-markdown.js": [
		64746,
		64746
	],
	"./prism-markdown.min": [
		16205,
		16205
	],
	"./prism-markdown.min.js": [
		16205,
		16205
	],
	"./prism-markup": [
		61687,
		61687
	],
	"./prism-markup-templating": [
		31559,
		31559
	],
	"./prism-markup-templating.js": [
		31559,
		31559
	],
	"./prism-markup-templating.min": [
		49837,
		49837
	],
	"./prism-markup-templating.min.js": [
		49837,
		49837
	],
	"./prism-markup.js": [
		61687,
		61687
	],
	"./prism-markup.min": [
		90950,
		90950
	],
	"./prism-markup.min.js": [
		90950,
		90950
	],
	"./prism-mata": [
		54732,
		54732
	],
	"./prism-mata.js": [
		54732,
		54732
	],
	"./prism-mata.min": [
		62397,
		62397
	],
	"./prism-mata.min.js": [
		62397,
		62397
	],
	"./prism-matlab": [
		97146,
		97146
	],
	"./prism-matlab.js": [
		97146,
		97146
	],
	"./prism-matlab.min": [
		57068,
		57068
	],
	"./prism-matlab.min.js": [
		57068,
		57068
	],
	"./prism-maxscript": [
		40594,
		40594
	],
	"./prism-maxscript.js": [
		40594,
		40594
	],
	"./prism-maxscript.min": [
		4202,
		4202
	],
	"./prism-maxscript.min.js": [
		4202,
		4202
	],
	"./prism-mel": [
		89542,
		89542
	],
	"./prism-mel.js": [
		89542,
		89542
	],
	"./prism-mel.min": [
		54876,
		54876
	],
	"./prism-mel.min.js": [
		54876,
		54876
	],
	"./prism-mermaid": [
		34706,
		34706
	],
	"./prism-mermaid.js": [
		34706,
		34706
	],
	"./prism-mermaid.min": [
		86744,
		86744
	],
	"./prism-mermaid.min.js": [
		86744,
		86744
	],
	"./prism-metafont": [
		34866,
		34866
	],
	"./prism-metafont.js": [
		34866,
		34866
	],
	"./prism-metafont.min": [
		26066,
		26066
	],
	"./prism-metafont.min.js": [
		26066,
		26066
	],
	"./prism-mizar": [
		2885,
		2885
	],
	"./prism-mizar.js": [
		2885,
		2885
	],
	"./prism-mizar.min": [
		63050,
		63050
	],
	"./prism-mizar.min.js": [
		63050,
		63050
	],
	"./prism-mongodb": [
		47230,
		47230
	],
	"./prism-mongodb.js": [
		47230,
		47230
	],
	"./prism-mongodb.min": [
		8609,
		8609
	],
	"./prism-mongodb.min.js": [
		8609,
		8609
	],
	"./prism-monkey": [
		3200,
		3200
	],
	"./prism-monkey.js": [
		3200,
		3200
	],
	"./prism-monkey.min": [
		36476,
		36476
	],
	"./prism-monkey.min.js": [
		36476,
		36476
	],
	"./prism-moonscript": [
		20287,
		20287
	],
	"./prism-moonscript.js": [
		20287,
		20287
	],
	"./prism-moonscript.min": [
		63260,
		63260
	],
	"./prism-moonscript.min.js": [
		63260,
		63260
	],
	"./prism-n1ql": [
		67814,
		67814
	],
	"./prism-n1ql.js": [
		67814,
		67814
	],
	"./prism-n1ql.min": [
		64852,
		64852
	],
	"./prism-n1ql.min.js": [
		64852,
		64852
	],
	"./prism-n4js": [
		38015,
		38015
	],
	"./prism-n4js.js": [
		38015,
		38015
	],
	"./prism-n4js.min": [
		73783,
		73783
	],
	"./prism-n4js.min.js": [
		73783,
		73783
	],
	"./prism-nand2tetris-hdl": [
		59219,
		59219
	],
	"./prism-nand2tetris-hdl.js": [
		59219,
		59219
	],
	"./prism-nand2tetris-hdl.min": [
		97639,
		97639
	],
	"./prism-nand2tetris-hdl.min.js": [
		97639,
		97639
	],
	"./prism-naniscript": [
		20755,
		20755
	],
	"./prism-naniscript.js": [
		20755,
		20755
	],
	"./prism-naniscript.min": [
		62031,
		62031
	],
	"./prism-naniscript.min.js": [
		62031,
		62031
	],
	"./prism-nasm": [
		29888,
		29888
	],
	"./prism-nasm.js": [
		29888,
		29888
	],
	"./prism-nasm.min": [
		22903,
		22903
	],
	"./prism-nasm.min.js": [
		22903,
		22903
	],
	"./prism-neon": [
		80130,
		80130
	],
	"./prism-neon.js": [
		80130,
		80130
	],
	"./prism-neon.min": [
		41814,
		41814
	],
	"./prism-neon.min.js": [
		41814,
		41814
	],
	"./prism-nevod": [
		64641,
		64641
	],
	"./prism-nevod.js": [
		64641,
		64641
	],
	"./prism-nevod.min": [
		26912,
		26912
	],
	"./prism-nevod.min.js": [
		26912,
		26912
	],
	"./prism-nginx": [
		25467,
		25467
	],
	"./prism-nginx.js": [
		25467,
		25467
	],
	"./prism-nginx.min": [
		1280,
		1280
	],
	"./prism-nginx.min.js": [
		1280,
		1280
	],
	"./prism-nim": [
		99621,
		99621
	],
	"./prism-nim.js": [
		99621,
		99621
	],
	"./prism-nim.min": [
		35923,
		35923
	],
	"./prism-nim.min.js": [
		35923,
		35923
	],
	"./prism-nix": [
		95093,
		95093
	],
	"./prism-nix.js": [
		95093,
		95093
	],
	"./prism-nix.min": [
		38700,
		38700
	],
	"./prism-nix.min.js": [
		38700,
		38700
	],
	"./prism-nsis": [
		29446,
		29446
	],
	"./prism-nsis.js": [
		29446,
		29446
	],
	"./prism-nsis.min": [
		2146,
		2146
	],
	"./prism-nsis.min.js": [
		2146,
		2146
	],
	"./prism-objectivec": [
		40525,
		40525
	],
	"./prism-objectivec.js": [
		40525,
		40525
	],
	"./prism-objectivec.min": [
		68164,
		68164
	],
	"./prism-objectivec.min.js": [
		68164,
		68164
	],
	"./prism-ocaml": [
		46707,
		46707
	],
	"./prism-ocaml.js": [
		46707,
		46707
	],
	"./prism-ocaml.min": [
		12347,
		12347
	],
	"./prism-ocaml.min.js": [
		12347,
		12347
	],
	"./prism-odin": [
		51164,
		51164
	],
	"./prism-odin.js": [
		51164,
		51164
	],
	"./prism-odin.min": [
		19096,
		19096
	],
	"./prism-odin.min.js": [
		19096,
		19096
	],
	"./prism-opencl": [
		99392,
		99392
	],
	"./prism-opencl.js": [
		99392,
		99392
	],
	"./prism-opencl.min": [
		38115,
		38115
	],
	"./prism-opencl.min.js": [
		38115,
		38115
	],
	"./prism-openqasm": [
		54481,
		54481
	],
	"./prism-openqasm.js": [
		54481,
		54481
	],
	"./prism-openqasm.min": [
		9356,
		9356
	],
	"./prism-openqasm.min.js": [
		9356,
		9356
	],
	"./prism-oz": [
		71209,
		71209
	],
	"./prism-oz.js": [
		71209,
		71209
	],
	"./prism-oz.min": [
		82592,
		82592
	],
	"./prism-oz.min.js": [
		82592,
		82592
	],
	"./prism-parigp": [
		19497,
		19497
	],
	"./prism-parigp.js": [
		19497,
		19497
	],
	"./prism-parigp.min": [
		22881,
		22881
	],
	"./prism-parigp.min.js": [
		22881,
		22881
	],
	"./prism-parser": [
		20617,
		20617
	],
	"./prism-parser.js": [
		20617,
		20617
	],
	"./prism-parser.min": [
		27321,
		27321
	],
	"./prism-parser.min.js": [
		27321,
		27321
	],
	"./prism-pascal": [
		76719,
		76719
	],
	"./prism-pascal.js": [
		76719,
		76719
	],
	"./prism-pascal.min": [
		81046,
		81046
	],
	"./prism-pascal.min.js": [
		81046,
		81046
	],
	"./prism-pascaligo": [
		2019,
		2019
	],
	"./prism-pascaligo.js": [
		2019,
		2019
	],
	"./prism-pascaligo.min": [
		35594,
		35594
	],
	"./prism-pascaligo.min.js": [
		35594,
		35594
	],
	"./prism-pcaxis": [
		77753,
		77753
	],
	"./prism-pcaxis.js": [
		77753,
		77753
	],
	"./prism-pcaxis.min": [
		14601,
		14601
	],
	"./prism-pcaxis.min.js": [
		14601,
		14601
	],
	"./prism-peoplecode": [
		95270,
		95270
	],
	"./prism-peoplecode.js": [
		95270,
		95270
	],
	"./prism-peoplecode.min": [
		28007,
		28007
	],
	"./prism-peoplecode.min.js": [
		28007,
		28007
	],
	"./prism-perl": [
		90360,
		90360
	],
	"./prism-perl.js": [
		90360,
		90360
	],
	"./prism-perl.min": [
		77082,
		77082
	],
	"./prism-perl.min.js": [
		77082,
		77082
	],
	"./prism-php": [
		90706,
		90706
	],
	"./prism-php-extras": [
		1818,
		1818
	],
	"./prism-php-extras.js": [
		1818,
		1818
	],
	"./prism-php-extras.min": [
		24945,
		24945
	],
	"./prism-php-extras.min.js": [
		24945,
		24945
	],
	"./prism-php.js": [
		90706,
		90706
	],
	"./prism-php.min": [
		82121,
		82121
	],
	"./prism-php.min.js": [
		82121,
		82121
	],
	"./prism-phpdoc": [
		29836,
		29836
	],
	"./prism-phpdoc.js": [
		29836,
		29836
	],
	"./prism-phpdoc.min": [
		21558,
		21558
	],
	"./prism-phpdoc.min.js": [
		21558,
		21558
	],
	"./prism-plant-uml": [
		70106,
		70106
	],
	"./prism-plant-uml.js": [
		70106,
		70106
	],
	"./prism-plant-uml.min": [
		8475,
		8475
	],
	"./prism-plant-uml.min.js": [
		8475,
		8475
	],
	"./prism-plsql": [
		99712,
		99712
	],
	"./prism-plsql.js": [
		99712,
		99712
	],
	"./prism-plsql.min": [
		26398,
		26398
	],
	"./prism-plsql.min.js": [
		26398,
		26398
	],
	"./prism-powerquery": [
		32534,
		32534
	],
	"./prism-powerquery.js": [
		32534,
		32534
	],
	"./prism-powerquery.min": [
		40209,
		40209
	],
	"./prism-powerquery.min.js": [
		40209,
		40209
	],
	"./prism-powershell": [
		86777,
		86777
	],
	"./prism-powershell.js": [
		86777,
		86777
	],
	"./prism-powershell.min": [
		74346,
		74346
	],
	"./prism-powershell.min.js": [
		74346,
		74346
	],
	"./prism-processing": [
		79685,
		79685
	],
	"./prism-processing.js": [
		79685,
		79685
	],
	"./prism-processing.min": [
		99872,
		99872
	],
	"./prism-processing.min.js": [
		99872,
		99872
	],
	"./prism-prolog": [
		11130,
		11130
	],
	"./prism-prolog.js": [
		11130,
		11130
	],
	"./prism-prolog.min": [
		98140,
		98140
	],
	"./prism-prolog.min.js": [
		98140,
		98140
	],
	"./prism-promql": [
		84659,
		84659
	],
	"./prism-promql.js": [
		84659,
		84659
	],
	"./prism-promql.min": [
		11083,
		11083
	],
	"./prism-promql.min.js": [
		11083,
		11083
	],
	"./prism-properties": [
		56018,
		56018
	],
	"./prism-properties.js": [
		56018,
		56018
	],
	"./prism-properties.min": [
		54779,
		54779
	],
	"./prism-properties.min.js": [
		54779,
		54779
	],
	"./prism-protobuf": [
		50605,
		50605
	],
	"./prism-protobuf.js": [
		50605,
		50605
	],
	"./prism-protobuf.min": [
		17257,
		17257
	],
	"./prism-protobuf.min.js": [
		17257,
		17257
	],
	"./prism-psl": [
		45002,
		45002
	],
	"./prism-psl.js": [
		45002,
		45002
	],
	"./prism-psl.min": [
		32695,
		32695
	],
	"./prism-psl.min.js": [
		32695,
		32695
	],
	"./prism-pug": [
		9352,
		9352
	],
	"./prism-pug.js": [
		9352,
		9352
	],
	"./prism-pug.min": [
		32763,
		32763
	],
	"./prism-pug.min.js": [
		32763,
		32763
	],
	"./prism-puppet": [
		30194,
		30194
	],
	"./prism-puppet.js": [
		30194,
		30194
	],
	"./prism-puppet.min": [
		18383,
		18383
	],
	"./prism-puppet.min.js": [
		18383,
		18383
	],
	"./prism-pure": [
		31300,
		31300
	],
	"./prism-pure.js": [
		31300,
		31300
	],
	"./prism-pure.min": [
		96345,
		96345
	],
	"./prism-pure.min.js": [
		96345,
		96345
	],
	"./prism-purebasic": [
		23437,
		23437
	],
	"./prism-purebasic.js": [
		23437,
		23437
	],
	"./prism-purebasic.min": [
		92651,
		92651
	],
	"./prism-purebasic.min.js": [
		92651,
		92651
	],
	"./prism-purescript": [
		96062,
		96062
	],
	"./prism-purescript.js": [
		96062,
		96062
	],
	"./prism-purescript.min": [
		61549,
		61549
	],
	"./prism-purescript.min.js": [
		61549,
		61549
	],
	"./prism-python": [
		17479,
		17479
	],
	"./prism-python.js": [
		17479,
		17479
	],
	"./prism-python.min": [
		50876,
		50876
	],
	"./prism-python.min.js": [
		50876,
		50876
	],
	"./prism-q": [
		80835,
		80835
	],
	"./prism-q.js": [
		80835,
		80835
	],
	"./prism-q.min": [
		22890,
		22890
	],
	"./prism-q.min.js": [
		22890,
		22890
	],
	"./prism-qml": [
		37013,
		37013
	],
	"./prism-qml.js": [
		37013,
		37013
	],
	"./prism-qml.min": [
		17635,
		17635
	],
	"./prism-qml.min.js": [
		17635,
		17635
	],
	"./prism-qore": [
		22106,
		22106
	],
	"./prism-qore.js": [
		22106,
		22106
	],
	"./prism-qore.min": [
		25034,
		25034
	],
	"./prism-qore.min.js": [
		25034,
		25034
	],
	"./prism-qsharp": [
		95633,
		95633
	],
	"./prism-qsharp.js": [
		95633,
		95633
	],
	"./prism-qsharp.min": [
		35284,
		35284
	],
	"./prism-qsharp.min.js": [
		35284,
		35284
	],
	"./prism-r": [
		46494,
		46494
	],
	"./prism-r.js": [
		46494,
		46494
	],
	"./prism-r.min": [
		22687,
		22687
	],
	"./prism-r.min.js": [
		22687,
		22687
	],
	"./prism-racket": [
		62671,
		62671
	],
	"./prism-racket.js": [
		62671,
		62671
	],
	"./prism-racket.min": [
		20864,
		20864
	],
	"./prism-racket.min.js": [
		20864,
		20864
	],
	"./prism-reason": [
		75529,
		75529
	],
	"./prism-reason.js": [
		75529,
		75529
	],
	"./prism-reason.min": [
		17330,
		17330
	],
	"./prism-reason.min.js": [
		17330,
		17330
	],
	"./prism-regex": [
		44319,
		44319
	],
	"./prism-regex.js": [
		44319,
		44319
	],
	"./prism-regex.min": [
		44439,
		44439
	],
	"./prism-regex.min.js": [
		44439,
		44439
	],
	"./prism-rego": [
		7828,
		7828
	],
	"./prism-rego.js": [
		7828,
		7828
	],
	"./prism-rego.min": [
		67201,
		67201
	],
	"./prism-rego.min.js": [
		67201,
		67201
	],
	"./prism-renpy": [
		15097,
		15097
	],
	"./prism-renpy.js": [
		15097,
		15097
	],
	"./prism-renpy.min": [
		23760,
		23760
	],
	"./prism-renpy.min.js": [
		23760,
		23760
	],
	"./prism-rescript": [
		18185,
		18185
	],
	"./prism-rescript.js": [
		18185,
		18185
	],
	"./prism-rescript.min": [
		67614,
		67614
	],
	"./prism-rescript.min.js": [
		67614,
		67614
	],
	"./prism-rest": [
		94830,
		94830
	],
	"./prism-rest.js": [
		94830,
		94830
	],
	"./prism-rest.min": [
		58185,
		58185
	],
	"./prism-rest.min.js": [
		58185,
		58185
	],
	"./prism-rip": [
		20848,
		20848
	],
	"./prism-rip.js": [
		20848,
		20848
	],
	"./prism-rip.min": [
		30955,
		30955
	],
	"./prism-rip.min.js": [
		30955,
		30955
	],
	"./prism-roboconf": [
		76328,
		76328
	],
	"./prism-roboconf.js": [
		76328,
		76328
	],
	"./prism-roboconf.min": [
		80513,
		80513
	],
	"./prism-roboconf.min.js": [
		80513,
		80513
	],
	"./prism-robotframework": [
		34618,
		34618
	],
	"./prism-robotframework.js": [
		34618,
		34618
	],
	"./prism-robotframework.min": [
		51561,
		51561
	],
	"./prism-robotframework.min.js": [
		51561,
		51561
	],
	"./prism-ruby": [
		45470,
		45470
	],
	"./prism-ruby.js": [
		45470,
		45470
	],
	"./prism-ruby.min": [
		41663,
		41663
	],
	"./prism-ruby.min.js": [
		41663,
		41663
	],
	"./prism-rust": [
		70457,
		70457
	],
	"./prism-rust.js": [
		70457,
		70457
	],
	"./prism-rust.min": [
		37829,
		37829
	],
	"./prism-rust.min.js": [
		37829,
		37829
	],
	"./prism-sas": [
		41404,
		41404
	],
	"./prism-sas.js": [
		41404,
		41404
	],
	"./prism-sas.min": [
		91860,
		91860
	],
	"./prism-sas.min.js": [
		91860,
		91860
	],
	"./prism-sass": [
		80567,
		80567
	],
	"./prism-sass.js": [
		80567,
		80567
	],
	"./prism-sass.min": [
		83453,
		83453
	],
	"./prism-sass.min.js": [
		83453,
		83453
	],
	"./prism-scala": [
		66706,
		66706
	],
	"./prism-scala.js": [
		66706,
		66706
	],
	"./prism-scala.min": [
		79627,
		79627
	],
	"./prism-scala.min.js": [
		79627,
		79627
	],
	"./prism-scheme": [
		83809,
		83809
	],
	"./prism-scheme.js": [
		83809,
		83809
	],
	"./prism-scheme.min": [
		43958,
		43958
	],
	"./prism-scheme.min.js": [
		43958,
		43958
	],
	"./prism-scss": [
		81320,
		81320
	],
	"./prism-scss.js": [
		81320,
		81320
	],
	"./prism-scss.min": [
		56674,
		56674
	],
	"./prism-scss.min.js": [
		56674,
		56674
	],
	"./prism-shell-session": [
		91187,
		91187
	],
	"./prism-shell-session.js": [
		91187,
		91187
	],
	"./prism-shell-session.min": [
		45338,
		45338
	],
	"./prism-shell-session.min.js": [
		45338,
		45338
	],
	"./prism-smali": [
		52690,
		52690
	],
	"./prism-smali.js": [
		52690,
		52690
	],
	"./prism-smali.min": [
		59855,
		59855
	],
	"./prism-smali.min.js": [
		59855,
		59855
	],
	"./prism-smalltalk": [
		54549,
		54549
	],
	"./prism-smalltalk.js": [
		54549,
		54549
	],
	"./prism-smalltalk.min": [
		22489,
		22489
	],
	"./prism-smalltalk.min.js": [
		22489,
		22489
	],
	"./prism-smarty": [
		20685,
		20685
	],
	"./prism-smarty.js": [
		20685,
		20685
	],
	"./prism-smarty.min": [
		20215,
		20215
	],
	"./prism-smarty.min.js": [
		20215,
		20215
	],
	"./prism-sml": [
		84196,
		84196
	],
	"./prism-sml.js": [
		84196,
		84196
	],
	"./prism-sml.min": [
		71240,
		71240
	],
	"./prism-sml.min.js": [
		71240,
		71240
	],
	"./prism-solidity": [
		20474,
		20474
	],
	"./prism-solidity.js": [
		20474,
		20474
	],
	"./prism-solidity.min": [
		21338,
		21338
	],
	"./prism-solidity.min.js": [
		21338,
		21338
	],
	"./prism-solution-file": [
		57421,
		57421
	],
	"./prism-solution-file.js": [
		57421,
		57421
	],
	"./prism-solution-file.min": [
		80625,
		80625
	],
	"./prism-solution-file.min.js": [
		80625,
		80625
	],
	"./prism-soy": [
		86062,
		86062
	],
	"./prism-soy.js": [
		86062,
		86062
	],
	"./prism-soy.min": [
		92545,
		92545
	],
	"./prism-soy.min.js": [
		92545,
		92545
	],
	"./prism-sparql": [
		55560,
		55560
	],
	"./prism-sparql.js": [
		55560,
		55560
	],
	"./prism-sparql.min": [
		22969,
		22969
	],
	"./prism-sparql.min.js": [
		22969,
		22969
	],
	"./prism-splunk-spl": [
		61050,
		61050
	],
	"./prism-splunk-spl.js": [
		61050,
		61050
	],
	"./prism-splunk-spl.min": [
		76255,
		76255
	],
	"./prism-splunk-spl.min.js": [
		76255,
		76255
	],
	"./prism-sqf": [
		9859,
		9859
	],
	"./prism-sqf.js": [
		9859,
		9859
	],
	"./prism-sqf.min": [
		21601,
		21601
	],
	"./prism-sqf.min.js": [
		21601,
		21601
	],
	"./prism-sql": [
		37642,
		37642
	],
	"./prism-sql.js": [
		37642,
		37642
	],
	"./prism-sql.min": [
		36785,
		36785
	],
	"./prism-sql.min.js": [
		36785,
		36785
	],
	"./prism-squirrel": [
		51120,
		51120
	],
	"./prism-squirrel.js": [
		51120,
		51120
	],
	"./prism-squirrel.min": [
		61059,
		61059
	],
	"./prism-squirrel.min.js": [
		61059,
		61059
	],
	"./prism-stan": [
		54662,
		54662
	],
	"./prism-stan.js": [
		54662,
		54662
	],
	"./prism-stan.min": [
		47935,
		47935
	],
	"./prism-stan.min.js": [
		47935,
		47935
	],
	"./prism-stata": [
		26727,
		26727
	],
	"./prism-stata.js": [
		26727,
		26727
	],
	"./prism-stata.min": [
		16934,
		16934
	],
	"./prism-stata.min.js": [
		16934,
		16934
	],
	"./prism-stylus": [
		31457,
		31457
	],
	"./prism-stylus.js": [
		31457,
		31457
	],
	"./prism-stylus.min": [
		62210,
		62210
	],
	"./prism-stylus.min.js": [
		62210,
		62210
	],
	"./prism-supercollider": [
		53955,
		53955
	],
	"./prism-supercollider.js": [
		53955,
		53955
	],
	"./prism-supercollider.min": [
		21003,
		21003
	],
	"./prism-supercollider.min.js": [
		21003,
		21003
	],
	"./prism-swift": [
		25564,
		25564
	],
	"./prism-swift.js": [
		25564,
		25564
	],
	"./prism-swift.min": [
		26255,
		26255
	],
	"./prism-swift.min.js": [
		26255,
		26255
	],
	"./prism-systemd": [
		95082,
		95082
	],
	"./prism-systemd.js": [
		95082,
		95082
	],
	"./prism-systemd.min": [
		67696,
		67696
	],
	"./prism-systemd.min.js": [
		67696,
		67696
	],
	"./prism-t4-cs": [
		56972,
		56972
	],
	"./prism-t4-cs.js": [
		56972,
		56972
	],
	"./prism-t4-cs.min": [
		89890,
		89890
	],
	"./prism-t4-cs.min.js": [
		89890,
		89890
	],
	"./prism-t4-templating": [
		76176,
		76176
	],
	"./prism-t4-templating.js": [
		76176,
		76176
	],
	"./prism-t4-templating.min": [
		42589,
		42589
	],
	"./prism-t4-templating.min.js": [
		42589,
		42589
	],
	"./prism-t4-vb": [
		6145,
		6145
	],
	"./prism-t4-vb.js": [
		6145,
		6145
	],
	"./prism-t4-vb.min": [
		31242,
		31242
	],
	"./prism-t4-vb.min.js": [
		31242,
		31242
	],
	"./prism-tap": [
		77251,
		77251
	],
	"./prism-tap.js": [
		77251,
		77251
	],
	"./prism-tap.min": [
		49534,
		49534
	],
	"./prism-tap.min.js": [
		49534,
		49534
	],
	"./prism-tcl": [
		21382,
		21382
	],
	"./prism-tcl.js": [
		21382,
		21382
	],
	"./prism-tcl.min": [
		43025,
		43025
	],
	"./prism-tcl.min.js": [
		43025,
		43025
	],
	"./prism-textile": [
		72591,
		72591
	],
	"./prism-textile.js": [
		72591,
		72591
	],
	"./prism-textile.min": [
		11832,
		11832
	],
	"./prism-textile.min.js": [
		11832,
		11832
	],
	"./prism-toml": [
		14265,
		14265
	],
	"./prism-toml.js": [
		14265,
		14265
	],
	"./prism-toml.min": [
		90366,
		90366
	],
	"./prism-toml.min.js": [
		90366,
		90366
	],
	"./prism-tremor": [
		24114,
		24114
	],
	"./prism-tremor.js": [
		24114,
		24114
	],
	"./prism-tremor.min": [
		39830,
		39830
	],
	"./prism-tremor.min.js": [
		39830,
		39830
	],
	"./prism-tsx": [
		79904,
		79904
	],
	"./prism-tsx.js": [
		79904,
		79904
	],
	"./prism-tsx.min": [
		63402,
		63402
	],
	"./prism-tsx.min.js": [
		63402,
		63402
	],
	"./prism-tt2": [
		44376,
		44376
	],
	"./prism-tt2.js": [
		44376,
		44376
	],
	"./prism-tt2.min": [
		27497,
		27497
	],
	"./prism-tt2.min.js": [
		27497,
		27497
	],
	"./prism-turtle": [
		55394,
		55394
	],
	"./prism-turtle.js": [
		55394,
		55394
	],
	"./prism-turtle.min": [
		21885,
		21885
	],
	"./prism-turtle.min.js": [
		21885,
		21885
	],
	"./prism-twig": [
		45180,
		45180
	],
	"./prism-twig.js": [
		45180,
		45180
	],
	"./prism-twig.min": [
		64229,
		64229
	],
	"./prism-twig.min.js": [
		64229,
		64229
	],
	"./prism-typescript": [
		52619,
		52619
	],
	"./prism-typescript.js": [
		52619,
		52619
	],
	"./prism-typescript.min": [
		34586,
		34586
	],
	"./prism-typescript.min.js": [
		34586,
		34586
	],
	"./prism-typoscript": [
		47254,
		47254
	],
	"./prism-typoscript.js": [
		47254,
		47254
	],
	"./prism-typoscript.min": [
		78605,
		78605
	],
	"./prism-typoscript.min.js": [
		78605,
		78605
	],
	"./prism-unrealscript": [
		92939,
		92939
	],
	"./prism-unrealscript.js": [
		92939,
		92939
	],
	"./prism-unrealscript.min": [
		88189,
		88189
	],
	"./prism-unrealscript.min.js": [
		88189,
		88189
	],
	"./prism-uorazor": [
		70177,
		70177
	],
	"./prism-uorazor.js": [
		70177,
		70177
	],
	"./prism-uorazor.min": [
		92909,
		92909
	],
	"./prism-uorazor.min.js": [
		92909,
		92909
	],
	"./prism-uri": [
		61597,
		61597
	],
	"./prism-uri.js": [
		61597,
		61597
	],
	"./prism-uri.min": [
		3648,
		3648
	],
	"./prism-uri.min.js": [
		3648,
		3648
	],
	"./prism-v": [
		76289,
		76289
	],
	"./prism-v.js": [
		76289,
		76289
	],
	"./prism-v.min": [
		48420,
		48420
	],
	"./prism-v.min.js": [
		48420,
		48420
	],
	"./prism-vala": [
		5816,
		5816
	],
	"./prism-vala.js": [
		5816,
		5816
	],
	"./prism-vala.min": [
		5580,
		5580
	],
	"./prism-vala.min.js": [
		5580,
		5580
	],
	"./prism-vbnet": [
		96225,
		96225
	],
	"./prism-vbnet.js": [
		96225,
		96225
	],
	"./prism-vbnet.min": [
		34805,
		34805
	],
	"./prism-vbnet.min.js": [
		34805,
		34805
	],
	"./prism-velocity": [
		18971,
		18971
	],
	"./prism-velocity.js": [
		18971,
		18971
	],
	"./prism-velocity.min": [
		63141,
		63141
	],
	"./prism-velocity.min.js": [
		63141,
		63141
	],
	"./prism-verilog": [
		60173,
		60173
	],
	"./prism-verilog.js": [
		60173,
		60173
	],
	"./prism-verilog.min": [
		92828,
		92828
	],
	"./prism-verilog.min.js": [
		92828,
		92828
	],
	"./prism-vhdl": [
		41758,
		41758
	],
	"./prism-vhdl.js": [
		41758,
		41758
	],
	"./prism-vhdl.min": [
		10430,
		10430
	],
	"./prism-vhdl.min.js": [
		10430,
		10430
	],
	"./prism-vim": [
		76766,
		76766
	],
	"./prism-vim.js": [
		76766,
		76766
	],
	"./prism-vim.min": [
		9267,
		9267
	],
	"./prism-vim.min.js": [
		9267,
		9267
	],
	"./prism-visual-basic": [
		97772,
		97772
	],
	"./prism-visual-basic.js": [
		97772,
		97772
	],
	"./prism-visual-basic.min": [
		89,
		89
	],
	"./prism-visual-basic.min.js": [
		89,
		89
	],
	"./prism-warpscript": [
		3169,
		3169
	],
	"./prism-warpscript.js": [
		3169,
		3169
	],
	"./prism-warpscript.min": [
		46333,
		46333
	],
	"./prism-warpscript.min.js": [
		46333,
		46333
	],
	"./prism-wasm": [
		50877,
		50877
	],
	"./prism-wasm.js": [
		50877,
		50877
	],
	"./prism-wasm.min": [
		89110,
		89110
	],
	"./prism-wasm.min.js": [
		89110,
		89110
	],
	"./prism-web-idl": [
		42753,
		42753
	],
	"./prism-web-idl.js": [
		42753,
		42753
	],
	"./prism-web-idl.min": [
		36506,
		36506
	],
	"./prism-web-idl.min.js": [
		36506,
		36506
	],
	"./prism-wgsl": [
		6286,
		6286
	],
	"./prism-wgsl.js": [
		6286,
		6286
	],
	"./prism-wgsl.min": [
		28139,
		28139
	],
	"./prism-wgsl.min.js": [
		28139,
		28139
	],
	"./prism-wiki": [
		54230,
		54230
	],
	"./prism-wiki.js": [
		54230,
		54230
	],
	"./prism-wiki.min": [
		96049,
		96049
	],
	"./prism-wiki.min.js": [
		96049,
		96049
	],
	"./prism-wolfram": [
		85644,
		85644
	],
	"./prism-wolfram.js": [
		85644,
		85644
	],
	"./prism-wolfram.min": [
		68342,
		68342
	],
	"./prism-wolfram.min.js": [
		68342,
		68342
	],
	"./prism-wren": [
		19115,
		19115
	],
	"./prism-wren.js": [
		19115,
		19115
	],
	"./prism-wren.min": [
		98144,
		98144
	],
	"./prism-wren.min.js": [
		98144,
		98144
	],
	"./prism-xeora": [
		93201,
		93201
	],
	"./prism-xeora.js": [
		93201,
		93201
	],
	"./prism-xeora.min": [
		83153,
		83153
	],
	"./prism-xeora.min.js": [
		83153,
		83153
	],
	"./prism-xml-doc": [
		52962,
		52962
	],
	"./prism-xml-doc.js": [
		52962,
		52962
	],
	"./prism-xml-doc.min": [
		17569,
		17569
	],
	"./prism-xml-doc.min.js": [
		17569,
		17569
	],
	"./prism-xojo": [
		88391,
		88391
	],
	"./prism-xojo.js": [
		88391,
		88391
	],
	"./prism-xojo.min": [
		29818,
		29818
	],
	"./prism-xojo.min.js": [
		29818,
		29818
	],
	"./prism-xquery": [
		20149,
		20149
	],
	"./prism-xquery.js": [
		20149,
		20149
	],
	"./prism-xquery.min": [
		93555,
		93555
	],
	"./prism-xquery.min.js": [
		93555,
		93555
	],
	"./prism-yaml": [
		57010,
		57010
	],
	"./prism-yaml.js": [
		57010,
		57010
	],
	"./prism-yaml.min": [
		58434,
		58434
	],
	"./prism-yaml.min.js": [
		58434,
		58434
	],
	"./prism-yang": [
		44425,
		44425
	],
	"./prism-yang.js": [
		44425,
		44425
	],
	"./prism-yang.min": [
		24825,
		24825
	],
	"./prism-yang.min.js": [
		24825,
		24825
	],
	"./prism-zig": [
		32947,
		32947
	],
	"./prism-zig.js": [
		32947,
		32947
	],
	"./prism-zig.min": [
		11170,
		11170
	],
	"./prism-zig.min.js": [
		11170,
		11170
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 7 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 96316;
module.exports = webpackAsyncContext;